module.exports = __webpack_public_path__ + "media/images/sale_crm/leads-ef5841d286e6c8edea1501259869b4db.svg";